<template>
  <form id="invoiceFilterForm" method="post" class="filter-datatable"
        @submit.prevent="filter">
    <h3>Zoek op:</h3>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <input-field
          id="invoiceNumber"
          :$v="$v.invoiceNumber"
          :value="invoiceNumber"
          :required="false"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          :label="this.$t('invoice.invoice-number')"
          validation-message-translation-name-space="InvoiceFilterForm"
          name="invoice-number"
          @input="setInvoiceNumber"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <date-picker-field
          id="invoiceDate"
          :value="invoiceDate"
          :$v="$v.invoiceDate"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          :label="this.$t('invoice.invoice-date')"
          validation-message-translation-name-space="InvoiceFilterForm"
          name="invoice-date"
          @input="setInvoiceDate"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <select-field
          id="invoiceMonth"
          :$v="$v.invoiceMonth"
          :value="invoiceMonth"
          :options="invoiceMonthOptions"
          :required="false"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          :label="this.$t('invoice.invoice-month')"
          validation-message-translation-name-space="InvoiceFilterForm"
          name="invoice-month"
          @change="setInvoiceMonth"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <select-field
          id="invoiceYear"
          :$v="$v.invoiceYear"
          :value="invoiceYear"
          :options="invoiceYearOptions"
          :required="false"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          :label="this.$t('invoice.invoice-year')"
          validation-message-translation-name-space="InvoiceFilterForm"
          name="invoice-number"
          @change="setInvoiceYear"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <div class="gridelement formsectioncompound">
          <div class="jq_gridcontentarea">
            <div class="wm-field small-12 columns">
              <div class="wm-field-input">
                <input id="filterSubmit" :value="this.$t('invoice.search')" type="submit" class="confirmation">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import DatePickerField from './fields/DatePickerField'
import InputField from './fields/InputField'
import SelectField from './fields/SelectField'

export default {
  name: 'InvoiceFilterBaseForm',
  components: {
    DatePickerField,
    SelectField,
    InputField
  },
  data () {
    return {
      invoiceMonthOptions: [
        { value: '', text: this.$t('invoice.select-month') },
        { value: '1', text: this.$t('datepicker.months.january') },
        { value: '2', text: this.$t('datepicker.months.february') },
        { value: '3', text: this.$t('datepicker.months.march') },
        { value: '4', text: this.$t('datepicker.months.april') },
        { value: '5', text: this.$t('datepicker.months.may') },
        { value: '6', text: this.$t('datepicker.months.june') },
        { value: '7', text: this.$t('datepicker.months.july') },
        { value: '8', text: this.$t('datepicker.months.august') },
        { value: '9', text: this.$t('datepicker.months.september') },
        { value: '10', text: this.$t('datepicker.months.october') },
        { value: '11', text: this.$t('datepicker.months.november') },
        { value: '12', text: this.$t('datepicker.months.december') }
      ],
      invoiceYearOptions: this.getInvoiceYearOptions()
    }
  },
  validations () {
    return {
      invoiceNumber: {},
      invoiceDate: {},
      invoiceMonth: {},
      invoiceYear: {}
    }
  },
  methods: {
    getInvoiceYearOptions: function () {
      const currentYear = new Date().getFullYear()
      return [
        { value: '', text: this.$t('invoice.select-year') },
        { value: currentYear - 6, text: currentYear - 6 },
        { value: currentYear - 5, text: currentYear - 5 },
        { value: currentYear - 4, text: currentYear - 4 },
        { value: currentYear - 3, text: currentYear - 3 },
        { value: currentYear - 2, text: currentYear - 2 },
        { value: currentYear - 1, text: currentYear - 1 },
        { value: currentYear, text: currentYear }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/InvoiceFilterBaseForm.vue